import { Link } from "src/sudokit/components/Link";
import VStack from "src/sudokit/Layout/VStack";

export const BillingAlert = ({ error }) => {
  if (!error) return null;

  const isMobileSubscriptionError = typeof error === "object" && error.type === "mobile_subscription_active";
  const storeNameLookup = {
    app_store: "App Store",
    play_store: "Google Play Store",
  };
  const storeName = error?.storeName || storeNameLookup[error?.store] || "mobile app store";
  const manageUrl = error?.manageLink;

  return (
    <VStack
      align="center"
      justify="center"
      spacing={2}
      className="rounded-xl bg-app-danger-color-hover max-w-lg mx-auto my-4 pt-3 pb-4 px-4"
    >
      <p className="text-app-danger-color font-inter text-center">
        {isMobileSubscriptionError
          ? error.message
          : "Something went wrong while updating your plan. Please refresh the page and try again, or contact support if the issue persists."}
      </p>

      {isMobileSubscriptionError ? (
        <>
          {manageUrl && (
            <a
              href={manageUrl}
              target="_blank"
              rel="noreferrer"
              className="font-inter text-app-danger-color underline"
            >
              Open {storeName}
            </a>
          )}
        </>
      ) : (
        <Link
          external
          href="/app/subscription/portal"
          className="font-inter text-app-danger-color underline"
        >
          View billing page
        </Link>
      )}
    </VStack>
  );
};
